import { useRef, useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

import FloatingActionButton from 'LuxKit/Button/FloatingActionButton'
import LineAngleUpIcon from 'LuxKit/Icons/line/LineAngleUpIcon'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import useToggle from 'hooks/useToggle'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import ModalContext from 'contexts/ModalContext'
import Modal from 'LuxKit/Modal/Modal'
import DropdownSheet from 'LuxKit/Dropdown/Sheet/DropdownSheet'
import MapLayersOptions from './MapLayersOptions'

const Container = styled.div`
  z-index: 5;
  position: absolute;
  bottom: ${rem(24)};
  left: ${rem(24)};
`

const DropUpContainer = styled(CSSBreakpoint)`
  display: flex;
`

function MapLayersButton() {
  const intl = useIntl()
  const buttonRef = useRef<HTMLButtonElement>(null)

  const { value: isDropdownOpen, toggle: toggleDropdown, off: closeDropdown } = useToggle()

  const isDesktop = useScreenSizeUp('desktop')

  const showModal = useContext(ModalContext)

  const openLayersModal = useCallback(() => {
    showModal(
      <Modal title={intl.formatMessage({
        id: 'rKGk5ohtHVe3yf8Xp-TW',
        defaultMessage: 'Map layers',
        description: 'Heading title for the modal showing map layer options',
      })}
      >
        <MapLayersOptions />
      </Modal>,
    )
  }, [showModal, intl])

  return (
    <Container>
      <FloatingActionButton
        kind="primary"
        variant="ghost"
        startIcon={<LineCalendarIcon />}
        ref={buttonRef}
        onClick={isDesktop ? toggleDropdown : openLayersModal}
      >
        <Group direction="horizontal" gap={8} verticalAlign="center">
          <div>
            {intl.formatMessage({
              id: 'qxVYZWw6IW1MQkxlUTnC',
              defaultMessage: 'View by dates',
              description: 'Action button label to filter map layers by trip dates',
            })}
          </div>
          <DropUpContainer min="desktop">
            <LineAngleUpIcon />
          </DropUpContainer>
        </Group>
      </FloatingActionButton>

      <DropdownSheet
        size="M"
        open={isDropdownOpen}
        placement="top-start"
        onClose={closeDropdown}
        anchorRef={buttonRef}
        triggerRef={buttonRef}
      >
        <MapLayersOptions />
      </DropdownSheet>
    </Container>
  )
}

export default MapLayersButton
